import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const projectLinks = [
  "AAN Productions",
  "AAN Events",
  "AAN Educ8",
  "TalentAfrica.net",
  "Adinkra Experience",
];

export default function Footer() {
  return (
    <footer className="bg-aan-footer text-white">
      <div className="mx-auto grid max-w-[1130px] gap-10 px-8 py-16 md:grid-cols-[1.15fr_1fr_1.05fr_1.2fr] md:gap-8 lg:py-20">
        <div className="text-center md:text-left">
          <img className="mx-auto w-52 md:mx-0" src="/assets/logo-white.png" alt="African Art Network" />
          <p className="mt-3 font-display text-[12px] font-semibold uppercase text-white">
            Promoting the African Experience
          </p>
        </div>

        <div className="border-white/60 md:border-r md:pr-8">
          <h3 className="font-display text-xl font-semibold text-aan-bright">Ticketing</h3>
          <ul className="mt-3 space-y-1 text-[12px] uppercase leading-tight text-white">
            <li>
              <Link className="hover:text-aan-bright" to="/screenings">
                Browse AAN Events
              </Link>
            </li>
            <li>
              <Link className="hover:text-aan-bright" to="/tickets">
                My Tickets
              </Link>
            </li>
            <li>
              <Link className="hover:text-aan-bright" to="/login">
                Customer Login
              </Link>
            </li>
          </ul>
          <p className="mt-5 text-justify text-[12px] leading-relaxed text-white/90">
            Buy African Art Network tickets, complete secure payment, and keep your QR passes ready for entry.
          </p>
        </div>

        <div className="border-white/60 md:border-r md:pr-8">
          <h3 className="font-display text-xl font-semibold text-aan-bright">Projects and Initiatives</h3>
          <ul className="mt-3 space-y-1 text-[12px] uppercase leading-tight text-white">
            {projectLinks.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
          <h3 className="mt-7 font-display text-xl font-semibold text-aan-bright">Vision:</h3>
          <p className="mt-2 text-justify text-[12px] leading-relaxed text-white/90">
            African Art Network promotes African arts and culture through productions, events, education, and creative
            platforms.
          </p>
        </div>

        <div>
          <h3 className="font-display text-xl font-semibold text-aan-bright">Book an Experience</h3>
          <p className="mt-3 text-justify text-[12px] leading-relaxed text-white/90">
            Discover upcoming AAN events and reserve your place through the ticketing flow.
          </p>
          <Link
            to="/screenings"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-white px-6 py-2 font-display text-[12px] font-black uppercase text-black transition hover:bg-aan-bright"
          >
            Browse Tickets
            <ArrowRight size={15} />
          </Link>
        </div>
      </div>
      <div className="bg-aan-footer px-6 pb-10 text-center text-[12px] text-white">
        THIS WEBSITE IS OWNED BY AFRICAN ART NETWORK LBG
      </div>
    </footer>
  );
}
